import CustomButton from 'components/Buttons/CustomButton';
import CustomInputField from 'components/InputFields/CustomInputField';
import CustomTextAreaField from 'components/InputFields/CustomTextAreaField';
import React, { useState } from 'react';
import axios from 'axios';

function FAQHubQuestionForm() {
  const buttonStates = {
    SENT: 'Question successfully sent',
    ERROR: 'Failed to send question',
  };
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [question, setQuestion] = useState('');

  const [errorTextName, setErrorTextName] = useState(null);
  const [errorTextEmail, setErrorTextEmail] = useState(null);
  const [errorTextQuestion, setErrorTextQuestion] = useState(null);

  const [stateText, setStateText] = useState(null);
  const onRetry = () => {
    setStateText(null);
  };
  const onHandleSendEmail = async () => {
    axios
      .post('/api/email_question', { email, name, question })
      .then((res) => {
        setStateText(buttonStates.SENT);
        resetErrors();
        resetFields();
        console.log(res);
      })
      .catch((e) => {
        setStateText(buttonStates.ERROR);
        console.log(e);
      });
  };
  const validateEmail = (emailAddress) => {
    return String(emailAddress)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };
  const resetFields = () => {
    setName('');
    setEmail('');
    setQuestion('');
  };
  const resetErrors = () => {
    setErrorTextName(null);
    setErrorTextEmail(null);
    setErrorTextQuestion(null);
  };
  const onSubmit = async () => {
    resetErrors();
    if (name === '') {
      setErrorTextName('Full name required');
      return;
    }
    if (email === '') {
      setErrorTextEmail('Email address required');
      return;
    }
    if (!validateEmail(email)) {
      setErrorTextEmail('Email address not valid');
      return;
    }
    if (question === '') {
      console.log(question);
      setErrorTextQuestion('Question required');
      return;
    }
    const result = await onHandleSendEmail();
    console.log(result);
    resetFields();
  };
  return (
    <>
      {stateText ? (
        <div className="state_text">
          {stateText === buttonStates.SENT ? (
            <div className="state_success">
              <p>{stateText}</p>
              <CustomButton text={'Ask another question'} onClick={onRetry} />
            </div>
          ) : (
            <div className="state_error">
              <p>{stateText}</p>
              <CustomButton text={'Retry'} onClick={onRetry} />
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="question_form_title">
            HAVE A QUESTION THAT’S NOT LISTED?
          </div>
          <p className="question_form_description">
            Please get in touch using the form below. We’ll get back to you as
            soon as we can to help you out and your question will be added to
            the hub to help out future users. Win win!
          </p>

          <div className="question_form">
            <CustomInputField
              placeholder={'Name'}
              value={name}
              onChange={(val) => setName(val)}
              errorText={errorTextName}
            />
            <CustomInputField
              placeholder={'Email Address'}
              type="email"
              value={email}
              onChange={(val) => setEmail(val)}
              errorText={errorTextEmail}
            />
            <CustomTextAreaField
              placeholder={'Type your question here'}
              value={question}
              onChange={(val) => setQuestion(val)}
              rows={4}
              errorText={errorTextQuestion}
            />
          </div>
          <div className="button_container">
            <CustomButton text={'Submit'} onClick={onSubmit} />
          </div>
        </div>
      )}
      <style jsx>{`
        .state_text {
          text-align: center;
          color: ${stateText === buttonStates.ERROR ? '#fd0300' : '#e4e4e4'};
        }
        .button_container {
          margin-top: 24px;
        }
        .question_form_title {
          font-family: 'big_noodle_titling';
          font-size: 31px;
          font-weight: 400;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: center;
          color: #e4e4e4;
        }
        .question_form_description {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: center;
          color: #e4e4e4;
          padding: 0;
          margin: 0;
          margin-top: 24px;
        }
        .question_form {
          margin-top: 40px;
          display: grid;
          gap: 16px;
        }
      `}</style>
    </>
  );
}

export default FAQHubQuestionForm;
